// AUTO-GENERATED by plugins/games-registry.ts - do not edit by hand.
// Regenerated on Vite buildStart / hot reload when src/games/* changes.

import type { GameRegistration } from '@nostr-gives/shared';

export type RegistryEntry = () => Promise<{ default?: GameRegistration } & Record<string, GameRegistration>>;
export const registry: Record<string, RegistryEntry> = {
  'acrostic': () => import('./acrostic'),
  'akari': () => import('./akari'),
  'anagram-sprint': () => import('./anagram-sprint'),
  'battleships': () => import('./battleships'),
  'chess-puzzle': () => import('./chess-puzzle'),
  'compound': () => import('./compound'),
  'connect4': () => import('./connect4'),
  'connections': () => import('./connections'),
  'cross-number': () => import('./cross-number'),
  'echo': () => import('./echo'),
  'flagle': () => import('./flagle'),
  'foldle': () => import('./foldle'),
  'game-2048': () => import('./game-2048'),
  'heardle': () => import('./heardle'),
  'kakuro': () => import('./kakuro'),
  'letter-boxed': () => import('./letter-boxed'),
  'leword': () => import('./leword'),
  'longword': () => import('./longword'),
  'mathdoku': () => import('./mathdoku'),
  'minesweeper': () => import('./minesweeper'),
  'mp-rps-spike': () => import('./mp-rps-spike'),
  'nerdle': () => import('./nerdle'),
  'nonogram': () => import('./nonogram'),
  'slitherlink': () => import('./slitherlink'),
  'spelling-bee': () => import('./spelling-bee'),
  'word-ladder': () => import('./word-ladder'),
  'worldle': () => import('./worldle'),
};

export const registryOrder = [
  'acrostic',
  'akari',
  'anagram-sprint',
  'battleships',
  'chess-puzzle',
  'compound',
  'connect4',
  'connections',
  'cross-number',
  'echo',
  'flagle',
  'foldle',
  'game-2048',
  'heardle',
  'kakuro',
  'letter-boxed',
  'leword',
  'longword',
  'mathdoku',
  'minesweeper',
  'mp-rps-spike',
  'nerdle',
  'nonogram',
  'slitherlink',
  'spelling-bee',
  'word-ladder',
  'worldle',
] as const;
